<template>
  <v-dialog persistent v-model="deleteDialog" max-width="450">
    <v-card>
      <v-card-title class="subtitle-1">
        {{ lang.general.areYouSure }}
      </v-card-title>

      <v-card-text v-if="suggestedActionType == 'accept'">
        <p class="subtitle-2">
          {{ lang.general.byDelete }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeDeleteItemDialog"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn small class="ml-2 btn-bg" elevation="0" @click="deleteItem()">
          {{ lang.actions.delete }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteItem",
  data() {
    return {};
  },
  props: {
    suggestedActionType: {
      type: String,
      default: "accept",
    },
    deleteDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    closeDeleteItemDialog() {
      this.$emit("closeDeleteItemDialog");
    },
    deleteItem() {
      this.$emit("deleteItem");
    },
  },
};
</script>
